// Generated by ReScript, PLEASE EDIT WITH CARE

import * as S from "sury/src/S.res.mjs";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";

var t = [
  {
    title: "Journey 1",
    id: "7"
  },
  {
    title: "Journey 2",
    id: "8"
  },
  {
    title: "Journey 3",
    id: "9"
  },
  {
    title: "Journey 4",
    id: "10"
  }
];

function journeyToColor(id) {
  switch (id) {
    case "10" :
        return "#bb8835";
    case "7" :
        return "#9e62a1";
    case "8" :
        return "#435eb8";
    case "9" :
        return "#1d7d50";
    default:
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "WordFlyersTypes.res",
              20,
              4
            ],
            Error: new Error()
          };
  }
}

var Journeys = {
  t: t,
  journeyToColor: journeyToColor
};

function unitMetaSchema(idx) {
  return S.object(function (s) {
              return {
                      idx: idx,
                      unit: "Unit " + (idx + 1 | 0).toString(),
                      title: s.f("text", S.string),
                      about: s.f("about", S.string),
                      textType: s.f("text_type", S.string),
                      thumbnail: s.f("thumbnail", S.string)
                    };
            });
}

function yearLevel(id) {
  switch (id) {
    case "10" :
        return "LEVEL_10";
    case "7" :
        return "LEVEL_7";
    case "8" :
        return "LEVEL_8";
    case "9" :
        return "LEVEL_9";
    default:
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "WordFlyersTypes.res",
              63,
              2
            ],
            Error: new Error()
          };
  }
}

function gateId(id) {
  switch (id) {
    case "0" :
        return 0;
    case "2" :
        return 2;
    case "3" :
        return 3;
    default:
      return 1;
  }
}

var Ctx = {
  name: "WordFlyersTypes"
};

var include = ContextMaker$LiteracyplanetClientFlags.Make(Ctx);

var WordFlyersMenuFragment;

var WordFlyersActivityFragment;

var initialContext = include.initialContext;

var context = include.context;

var P = include.P;

var Provider = include.Provider;

var ContextMakerProviderNotFound = include.ContextMakerProviderNotFound;

var use = include.use;

export {
  WordFlyersMenuFragment ,
  WordFlyersActivityFragment ,
  Journeys ,
  unitMetaSchema ,
  yearLevel ,
  gateId ,
  Ctx ,
  initialContext ,
  context ,
  P ,
  Provider ,
  ContextMakerProviderNotFound ,
  use ,
}
/* include Not a pure module */
